// Is this a phone-shaped device — i.e. should we render the mobile layout?
//
// Deliberately measures the SHORTEST viewport edge, never innerWidth. A phone in
// landscape is still a phone, but innerWidth jumps past the breakpoint the moment
// it's rotated. Because App renders a different component tree for mobile than for
// desktop, that flip unmounted and rebuilt the entire page mid-flow: rotating the
// phone during the stop-timer flow threw away the required job note modal along
// with its state, and the crew walked away without leaving a note. The timer is
// already clocked out by then, so there was no second chance to ask.
//
// The pointer test keeps a touchscreen laptop on the desktop layout no matter how
// its window is shaped — a mouse reports a fine pointer, a finger a coarse one.
export const MOBILE_BREAKPOINT = 768;

export function isMobileLayout() {
  if (typeof window === 'undefined') return false;
  if (window.Capacitor?.isNativePlatform?.()) return true;

  if (Math.min(window.innerWidth, window.innerHeight) > MOBILE_BREAKPOINT) return false;

  const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)');
  if (coarse) return coarse.matches;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export default isMobileLayout;
